import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
import './mock'
import './utils/permission' // permission control
import VueParticles from 'vue-particles'  
const app = createApp(App)

app.use(store)
  .use(router)
  .use(ViewUIPlus)
  .use(VueParticles)
  .mount('#app')
